import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';
import bg from 'static/images/domru-internet/world-internet.jpg';
import * as S from '../styled';

export const Section = styled.div`
    padding-top: 0;
`;

export const CounterWrap = styled.div`
    width: 100%;
    padding: 105px 0;
    background-image: url(${bg});
    background-repeat: no-repeat;
    background-size: cover;
`;

export const CounterList = styled(S.List)`
    @media(max-width: ${S.breakePoints.mobile}) {
        flex-direction: column;
    }
`;

export const CounterValue = styled(S.DataTitle)`
    text-align: center;
    ${FONTS.H0};
    color: ${COLORS.red};

    @media(max-width: ${S.breakePoints.tablet}) {
        ${FONTS.H2};
    }

    @media(max-width: ${S.breakePoints.mobile}) {
        ${FONTS.H0};
    }
`;

export const CounterText = styled(S.DataText)`
    margin-bottom: 20px;
    text-align: center;
    justify-content: center;
`;

export const List = styled(S.List)`
    padding-top: 110px;

    @media(max-width: ${S.breakePoints.mobile}) {
        flex-direction: column;
    }
`;

export const ListItem = styled(S.ListItem)`
    flex: 1 1 33%;
    align-items: center;

    @media(max-width: ${S.breakePoints.mobile}) {
        flex: 1 1 100%;
        align-items: flex-start;
        margin-right: 0;
        margin-bottom: 30px;
    }
`;

export const ImgWrap = styled(S.ImgWrap)`
    align-self: flex-start;
    margin-bottom: 25px;
    height: 40px;
    width: auto;
    height: 40px;
`;

export const DataTitle = styled(S.DataTitle)`
    margin-bottom: 10px;
    min-height: 64px;
    text-align: left;

    @media(max-width: ${S.breakePoints.mobile}) {
        min-height: auto;
    }
`;

export const DataText = styled(S.DataText)`
    margin-bottom: 20px;
    text-align: left;
`;
